"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HandleRoundedArrow = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icons = require("@material-ui/icons");

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var HandleRoundedArrow = function HandleRoundedArrow(_ref) {
  var props = _ref.props,
      screenSize = _ref.screenSize;
  var useStyles = (0, _core.makeStyles)(function (theme) {
    return {
      arrow: {
        color: theme.palette.text.secondary
      },
      hidden: {
        opacity: 0
      }
    };
  });
  var classes = useStyles();

  if (props.direction === 'left') {
    return /*#__PURE__*/_react.default.createElement(_icons.KeyboardArrowLeftRounded, _extends({
      classes: {
        root: classes.arrow
      },
      style: screenSize !== 'mobile' ? {
        marginTop: 12,
        width: 40
      } : {
        marginTop: 16,
        width: 40
      }
    }, props));
  }

  if (props.direction === 'right') {
    return /*#__PURE__*/_react.default.createElement(_icons.KeyboardArrowRightRounded, _extends({
      classes: {
        root: classes.arrow
      },
      style: screenSize !== 'mobile' ? {
        marginTop: 12,
        width: 40
      } : {
        marginTop: 16,
        width: 40
      }
    }, props));
  }

  return null;
};

exports.HandleRoundedArrow = HandleRoundedArrow;
HandleRoundedArrow.propTypes = {
  props: _propTypes.default.objectOf(_propTypes.default.object).isRequired,
  direction: _propTypes.default.string.isRequired,
  screenSize: _propTypes.default.string.isRequired,
  disabled: _propTypes.default.bool
};
HandleRoundedArrow.defaultProps = {
  disabled: false
};
var _default = HandleRoundedArrow;
exports.default = _default;